import React, { useEffect, useRef, memo } from "react";

function TradingViewWidget({ data }) {
  const container = useRef();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && data) {
      const configObj = JSON.stringify(data);
      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
      script.type = "text/javascript";
      script.async = true;
      script.innerHTML = configObj;
      container.current.appendChild(script);
      initialized.current = true;
    }
  }, [data, container, initialized]);

  return (
    <div
      className='tradingview-widget-container'
      ref={container}
      style={{ height: "100%", width: "100%" }}
    >
      <div
        className='tradingview-widget-container__widget'
        style={{ height: "100%", width: "100%" }}
      ></div>
    </div>
  );
}

export default memo(TradingViewWidget);
